import * as queries from "../../graphql/queries";
import * as mutations from "../../graphql/mutations";
import {
  CreateNetworkProgramInput,
  CreateNetworkProgramMutation,
  CreateNetworkProgramMutationVariables,
  DeleteNetworkProgramInput,
  DeleteNetworkProgramMutation,
  DeleteNetworkProgramMutationVariables,
  ListNetworkProgramsQuery,
  ListNetworkProgramsQueryVariables,
  ListNetworksQuery,
  ModelNetworkConnection,
  ModelNetworkProgramConnection,
  Network,
  NetworkProgram
} from "../../API";
import { genericQuery, fetchAllWithPagination, listQueryAutoPaginated } from "../api/apiUtils";

export const fetchAllNetworks = async (): Promise<Network[] | null> => {
  return await fetchAllWithPagination<Network>("networks", "networks", 500);
};

export const fetchNetworkProgramsByPrograms = async (programIds: string[]) => {
  const predicate: ListNetworkProgramsQueryVariables = {
    filter: {
      or: programIds.map((programId) => ({ programID: { eq: programId } }))
    }
  };
  return await listQueryAutoPaginated<
    ListNetworkProgramsQuery,
    NetworkProgram,
    ModelNetworkProgramConnection
  >(queries.listNetworkPrograms, "listNetworkPrograms", "items", predicate);
};

export async function deleteNetworkProgram(id: string) {
  const input: DeleteNetworkProgramInput = {
    id: id
  };
  const variables: DeleteNetworkProgramMutationVariables = {
    input: input
  };
  return await genericQuery<DeleteNetworkProgramMutation, NetworkProgram>(
    mutations.deleteNetworkProgram,
    "deleteNetworkProgram",
    variables
  );
}

export async function createNetworkProgram(
  programId: string,
  networkId: string
) {
  const input: CreateNetworkProgramInput = {
    programID: programId,
    networkID: networkId
  };
  const variables: CreateNetworkProgramMutationVariables = {
    input: input
  };
  //
  // return await genericQuery<CreateNetworkProgramMutation, NetworkProgram>(
  //   mutations.createNetworkProgram,
  //   "createNetworkProgram",
  //   variables
  // );

  console.error("createNetworkProgram is deprecated. Network associations are now created via the program-create endpoint. Do not call this function.");
}
